<template>
  <div class="container my-5">
    <div v-html="data"></div>
  </div>
</template>

<script>
export default {
  metaInfo: function () {
    return {
      title: 'Privacy',
    };
  },
  data() {
    return { data: null };
  },
  mounted() {
    let identifier = 'privacy-policy';

    if (this.isRTL) identifier += '-hadaf';

    this.$http.get('/api/cms-blocks/' + identifier).then(response => {
      this.data = response.data.content;
    });
  },
};
</script>